// @flow
import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Battle } from 'components/battle'
import './styles.scss'

import animationShower from '../../images/shower.json'
import animationHairdryer from '../../images/hairdryer.json'
import animationVent from '../../images/vent.json'
import animationLight from '../../images/light.json'
import animationMicrowave from '../../images/microwave.json'
import animationSpaghetti from '../../images/spaghetti.json'
import animationVacuum from '../../images/vacuum.json'
import animationStreaming from '../../images/streaming.json'
import animationRadiator from '../../images/radiator.json'
import animationDishes from '../../images/dishes.json'
import animationOven from '../../images/oven.json'
import animationSmartphone from '../../images/smartphone.json'
import animationWashing from '../../images/washing.json'
import animationTumbler from '../../images/tumbler.json'

const isMobile = browserCheck.isMobile

export class Stepper extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      currentSlide: 0
    }
  }

  next = () => {
    this.setState((state) => ({
        currentSlide: state.currentSlide + 1,
    }))
    // track in google analytics
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: `next-question:` + (this.state.currentSlide + 1)
    })
  }

  prev = () => {
      this.setState((state) => ({
          currentSlide: state.currentSlide - 1,
      }))
  }

  updateCurrentSlide = (index) => {
    const { currentSlide } = this.state;

    if (currentSlide !== index) {
        this.setState({
            currentSlide: index,
        })
    }
  }

  componentDidMount() {}

  render() {
    return <div className='stepper'>
          <h3>Was verbraucht mehr Strom?</h3>
          <div className='status'>{this.state.currentSlide+1}/7</div>
          <Carousel
              selectedItem={this.state.currentSlide}
              onChange={this.updateCurrentSlide}
              showThumbs={false}
              showArrows={false}
              showIndicators={false}
              showStatus={false}
              infiniteLoop={true}
              swipeable={false}
              ref="carouselContainer"
            >
              <div className='step'>
                <Battle
                  questionID='duschen-foehnen'
                  optionLeft='5 Minuten<br />warm duschen'
                  detailLeft={'durchschnittlicher Wasserverbrauch (Elektroboiler)'}
                  iconLeft={animationShower}
                  valueLeft={1.9}
                  optionRight='5 Minuten<br />Haare föhnen'
                  detailRight={'durchschnittliches Gerät'}
                  iconRight={animationHairdryer}
                  valueRight={0.1}
                  solution={'Duschen verbraucht deutlich mehr Energie.'}
                  tipps={'Mit einer Sparbrause brauchen sie nur halb so viel Wasser und Energie. Haartrockner gibt es mit unterschiedlichen Leistungsstufen. Kaufen Sie einen energiesparenden.'}
                />
              </div>
              <div className='step'>
                <Battle
                  questionID='ventilator-nachtlicht'
                  optionLeft='1 Stunde den Ventilator laufen lassen'
                  detailLeft={'ineffizientes Modell'}
                  iconLeft={animationVent}
                  valueLeft={0.1}
                  optionRight='12 Stunden Nachtlicht<br />fürs Baby'
                  detailRight={'durchschnittliches Gerät'}
                  iconRight={animationLight}
                  valueRight={0.01}
                  solution={'Ein Nachtlicht verbraucht weniger Energie.'}
                  tipps={'Beleuchtung sollte grundsätzlich überall ausgeschaltet werden, wo sie nicht benötigt wird. Das Babylicht braucht jedoch kaum Strom.'}
                />
              </div>
              <div className='step'>
                <Battle
                  questionID='mikrowelle-spaghetti'
                  optionLeft='2 Minuten Essen in der Mikrowelle wärmen'
                  detailLeft={'durchschnittliches Gerät'}
                  iconLeft={animationMicrowave}
                  valueLeft={0.03}
                  optionRight='Einen Topf Spaghetti kochen'
                  detailRight={'Pfanne mit Deckel'}
                  iconRight={animationSpaghetti}
                  valueRight={0.3}
                  solution={'Die Mikrowelle verbraucht weniger Energie.'}
                  tipps={'Achten Sie auf die Energieetikette: Effiziente Geräte brauchen bis zu 40 Prozent weniger Strom. Erhitzen Sie Wasser mit einem Wasserkocher, um Zeit und Strom zu sparen.'}
                />
              </div>
              <div className='step'>
                <Battle
                  questionID='staubsauger-netflix'
                  optionLeft='30 Minuten staubsaugen'
                  detailLeft={'sehr effizienter<br />Staubsauger'}
                  iconLeft={animationVacuum}
                  valueLeft={0.15}
                  optionRight='30 Minuten Netflix streamen'
                  detailRight={'PC mit grossem Monitor<br />(8K-Auflösung)'}
                  iconRight={animationStreaming}
                  valueRight={0.25}
                  solution={'Das Streamen verbraucht mehr Energie.'}
                  tipps={'Alte Staubsuager brauchen zwei- bis dreimal so viel Strom wie neure, sparsame Geräte. Ein kleiner Bildschirm braucht bis zu fünfmal weniger Strom. Zusätzlich sparen Sie, wenn Sie die Bildschirmhelligkeit reduzieren.'}
                />
              </div>
              <div className='step'>
                <Battle
                  questionID='ofen-geschirr'
                  optionLeft='1 Stunde mit dem Elektro-Ofen heizen'
                  detailLeft={'durchschnittliches Gerät'}
                  iconLeft={animationRadiator}
                  valueLeft={1.5}
                  optionRight='1 Waschgang des Geschirrspülers'
                  detailRight={'Normalprogramm einer Durchschnittsmaschine'}
                  iconRight={animationDishes}
                  valueRight={1.0}
                  solution={'Der Geschirrspüler verbraucht weniger Energie.'}
                  tipps={'Elektro-Öfen haben sehr unterschiedliche Leistungen. Kaufen Sie einen mit niedrigem Energieverbrauch und Thermostat. Wasschen mit dem Eco-Standardprogramm spart Strom.'}
                />
              </div>
              <div className='step'>
                <Battle
                  questionID='pizza-smartphone'
                  optionLeft='Eine Pizza im Backofen backen'
                  detailLeft={'effizienter Ofen mit Umluft'}
                  iconLeft={animationOven}
                  valueLeft={0.7}
                  optionRight='Das Smartphone aufladen'
                  detailRight={'durchschnittliches Modell'}
                  iconRight={animationSmartphone}
                  valueRight={0.04}
                  solution={'Das Laden des Smartphones verbraucht deutlich weniger Energie.'}
                  tipps={'Wählen Sie beim Backofen Umluft statt Ober-/Unterhitze, um Energie zu sparen. Nicht zu oft ein neues Handy kaufen. Denn am grössten ist der Energieverbrauch bei der Herstellung und der Entsorgung des Geräts.'}
                />
              </div>
              <div className='step'>
                <Battle
                  questionID='waschmaschine-tumbler'
                  optionLeft='Wäsche in der Maschine waschen'
                  detailLeft={'60° C mit einer Durchschnittsmaschine'}
                  iconLeft={animationWashing}
                  valueLeft={2.0}
                  optionRight='Wäsche im Tumbler trocknen'
                  detailRight={'Normalprogramm, ineffizientes Modell'}
                  iconRight={animationTumbler}
                  valueRight={1.6}
                  solution={'Eine 60°-Wäsche verbraucht mehr Energie.'}
                  tipps={'Die Waschtemperatur ist entscheidend. Kaltwaschen mit 20°C braucht nur 0,6 kWh Strom. Achten Sie auf die Energieetikette: Mit einem effizienten Tumbler brauchen Sie nur etwa 0,9 kWh.'}
                />
              </div>
            </Carousel>
            <div className="foot">
              <button onClick={this.next}>
                Nächste Frage
              </button>
            </div>
          </div>
  }
}
